export default __webpack_public_path__ + "static/media/managerIcon.3abf5ff8.jpg";